import React, { Fragment } from "react";
import PropTypes from "prop-types";
import ContainerDimensions from "react-container-dimensions";
import TreeMap from "../../../../../d3Components/treeMap";
import WithCard from "../../../../../common/withCard";
import "./treemapHolder.scss";

const TreemapHolder = ({ id, TreeData }) => {
  const modified_list = [];
  if (Object.keys(TreeData).length > 0) {
    for (let i in TreeData) {
      modified_list.push({ name: i, size: TreeData[i].toFixed(2) });
    }
  }
  const data = {
    name: "parent",
    children: [
      {
        name: "data",
        children: modified_list,
      },
    ],
  };
  return (
    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
      <WithCard>
        <h4 className="text-uppercase bold">Style Exposures</h4>
        <div id={id}>
          <div className="asset-class">
            <div>EXPOSURE CLASS</div>
          </div>
          {modified_list.length > 0 ? (
            <ContainerDimensions>
              {({ width }) => (
                <Fragment>
                  {width > 0 ? (
                    <TreeMap width={width} height={380} data={data} />
                  ) : null}
                </Fragment>
              )}
            </ContainerDimensions>
          ) : null}
        </div>
      </WithCard>
    </div>
  );
};

TreemapHolder.prototypes = {
  id: PropTypes.string.isRequired,
  TreeData: PropTypes.object.isRequired,
};
export default TreemapHolder;



// WEBPACK FOOTER //
// ./src/components/PortfolioDashboard/navigationPages/Component page/LiveAsset/section1/treemapHolder.jsx